import React from "react";
import { kebabCase } from "lodash";
import { Helmet } from "react-helmet";
import { Link, graphql } from "gatsby";
import Layout from "../components/Layout";
import SectionTitle from "../components/SectionTitle";

const BooksPage = ({ data }) => {
  const books = data.allMdx.edges.filter(
    (edge) => edge.node.frontmatter.isBook
  );
  return (
    <Layout>
      <Helmet>
        <title>Books</title>
      </Helmet>
      <div class="my-32">
        <div class="text-2xl mb-4 font-semibold">
          <SectionTitle>Library</SectionTitle>
        </div>
        <ul className="taglist">
          {books.map((edge) => (
            <li key={edge.node.frontmatter.title}>
              <Link className="font-serif underline" to={edge.node.fields.slug}>
                {edge.node.frontmatter.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </Layout>
  );
};

export default BooksPage;

export const bookPageQuery = graphql`
  query BooksQuery {
    allMdx {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            templateKey
            isBook
            date
            title
            description
            author
          }
        }
      }
    }
  }
`;
